module.exports = __webpack_public_path__ + "static/media/20240715_104956.fba4d1ec.jpg";